import React, { memo } from 'react';

export const TextQuestion = memo(function TextQuestion() {
    return (<div>Short text question.</div>);
});
